const $ = jQuery.noConflict();

class SetCaptPosition {
    constructor(caption, contentWrapper, lightbox, slideContent) {
        this.caption = caption;
        this.contentWrapper = contentWrapper;
        this.lightbox = lightbox;
        this.slideContent = slideContent;
    }
    init() {

        if($(this.caption).length > 0) {
            const sliderOffset = $(this.contentWrapper).offset().top - $(this.contentWrapper).parent().offset().top;
            const sliderHeight = $(this.contentWrapper).find(this.slideContent).outerHeight();
            const topDistance = sliderOffset + sliderHeight;
        
            $(this.caption).css({     
                'top': topDistance,
            });
        }
    }
}
const setCaptPosVideo = new SetCaptPosition('.lightbox--video .slider-caption', '.content-wrapper__inner', '.lightbox--video', 'iframe');
const setCaptPosGallery = new SetCaptPosition('.lightbox--gallery .slider-caption', '.content-wrapper__inner', '.lightbox--gallery', 'img');

export default setCaptPosVideo;
export { setCaptPosGallery };



